import { render, staticRenderFns } from "./DriverRegistration.vue?vue&type=template&id=77b9546e"
import script from "./DriverRegistration.vue?vue&type=script&lang=js"
export * from "./DriverRegistration.vue?vue&type=script&lang=js"
import style0 from "./DriverRegistration.vue?vue&type=style&index=0&id=77b9546e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports